const initilState = {
    byCategory: [],
    byAuthor: [],
    byRead: [],
    search: "",
  };
  
  export default initilState;
  